import { render, staticRenderFns } from "./ManagementAkun.vue?vue&type=template&id=095fdb8c&"
import script from "./ManagementAkun.vue?vue&type=script&lang=js&"
export * from "./ManagementAkun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports